/*
 * Function that will allow TS to filter out null and undefined values
 * */
export function isEmpty<TValue>(
  value: TValue | null | undefined
): value is TValue {
  return !(value === null || value === undefined)
}
